import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-051d19d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "annotation_container overflow-scroll" };
const _hoisted_2 = { class: "mt-4" };
const _hoisted_3 = { class: "flex flex-row items-start gap-4 p-2" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "text-gray-700 font-medium" };
const _hoisted_6 = { class: "text-gray-600 font-semibold ml-[13px] list-disc" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "mt-2 mb-2 border-t-gray-200" }, null, -1));
const _hoisted_8 = { class: "flex flex-row flex-wrap px-2 mt-1" };
const _hoisted_9 = { class: "w-8 h-8 bg-gray-100 p-[6px] rounded-full flex items-center justify-center" };
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = { class: "text-gray-700" };
import { UIModal, UIModalHeader } from '@gohighlevel/ghl-ui';
import checked from '../../assets/checked.png';
import filled from '../../assets/filled.png';
import outlined from '../../assets/outlined.png';
import strike from '../../assets/strike.png';
import strip from '../../assets/strip.png';
import apple from '../../assets/apple.png';
import blockedSlot from '../../assets/blocked.png';
import event from '../../assets/event.png';
import google from '../../assets/google.png';
import outlook from '../../assets/outlook.png';
import recurring from '../../assets/recurring.png';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalendarAnnotation',
    props: {
        showModal: Boolean,
        onClickClose: Function,
    },
    setup(__props) {
        const calendarAnnotationData = [
            {
                image: filled,
                title: 'Filled Box (Event Color)',
                info: ['Confirmed appointments', 'Showed appointments'],
            },
            {
                image: outlined,
                title: 'Outlined Box',
                info: [
                    'Unconfirmed appointments',
                    'Third party calendars marked as Free',
                    'Invalid appointments',
                ],
            },
            {
                image: strike,
                title: 'Outlined Box with strikethrough text',
                info: ['Cancelled appointments', 'No-show appointments'],
            },
            {
                image: checked,
                title: 'Filled Box (Gray)',
                info: ['Blocked slots', 'Third party calendars marked as Busy'],
            },
            {
                image: strip,
                title: 'Colored strip to left',
                info: [
                    'Selected User color',
                    'Selected Group color',
                    'Selected Calendar color',
                ],
            },
        ];
        const eventType = [
            {
                image: google,
                title: 'Google calendar',
            },
            {
                image: outlook,
                title: 'Outlook calendar',
            },
            {
                image: apple,
                title: 'Apple calendar',
            },
            {
                image: blockedSlot,
                title: 'Blocked off slot',
            },
            {
                image: recurring,
                title: 'Recurring event',
            },
            {
                image: event,
                title: 'Event error',
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(UIModal), {
                    show: __props.showModal,
                    width: 515
                }, {
                    header: _withCtx(() => [
                        _createVNode(_unref(UIModalHeader), {
                            id: "annotations-header",
                            title: "Calendar annotation ",
                            description: "Patterns and icons used in calendar view",
                            onClose: _cache[0] || (_cache[0] = ($event) => (__props.onClickClose()))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(calendarAnnotationData, (data, index) => {
                                    return _createElementVNode("div", { key: index }, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("img", {
                                                src: data.image,
                                                alt: data.title
                                            }, null, 8, _hoisted_4),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_5, _toDisplayString(data.title), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.info, (info, index1) => {
                                                    return (_openBlock(), _createElementBlock("ul", { key: index1 }, [
                                                        _createElementVNode("li", _hoisted_6, _toDisplayString(info), 1)
                                                    ]));
                                                }), 128))
                                            ])
                                        ]),
                                        _hoisted_7
                                    ]);
                                }), 64))
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(eventType, (event, index) => {
                                    return _createElementVNode("div", {
                                        key: index,
                                        class: "flex w-1/2 items-center py-2 gap-3"
                                    }, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("img", {
                                                src: event.image,
                                                alt: event.title,
                                                class: "object-cover"
                                            }, null, 8, _hoisted_10)
                                        ]),
                                        _createElementVNode("div", _hoisted_11, _toDisplayString(event.title), 1)
                                    ]);
                                }), 64))
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
